<template>
  <div>
    <!-- <Row type="flex" class="code-row-bg">
      <Col span="3" offset>
        <Input
          class="search-ipt"
          type="text"
          v-model="searchIpt.big"
          placeholder="大题号"
          @on-enter="getNoticeList"
          clearable
        />
      </Col>
      <Col span="3" offset="1">
        <Input
          class="search-ipt"
          type="text"
          v-model="searchIpt.big"
          placeholder="大题号"
          @on-enter="getNoticeList"
          clearable
        />
      </Col>
      <Col span="3" offset="1">
        <Input
          class="search-ipt"
          type="text"
          v-model="searchIpt.big"
          placeholder="小题号"
          @on-enter="getNoticeList"
          clearable
        />
      </Col>
      <Col span="3" offset="1">
        <Input
          class="search-ipt"
          type="text"
          v-model="searchIpt.big"
          placeholder="请输入框ID"
          @on-enter="getNoticeList"
          clearable
        />
      </Col>
      <Col span="4" offset="1">
        <Button
          type="primary"
          icon="md-search"
          class="search_tn"
          data-level="common"
          @click="getNoticeList"
        >搜索</Button>
      </Col>
      <Col span="4" offset push="1">
        <Button class="add_item" icon="md-add" type="primary" @click="modal=true">上传图片</Button>
      </Col>
    </Row>-->
    <div class="table">
      <Table border :columns="tables" :data="tableData" ref="table">
        <template slot-scope="{ row }" slot="img">
          <span
            style="color:#1E77F7;cursor:pointer;"
            v-if="!row.image"
            @click="addImg(row.detailId)"
          >添加</span>
          <div v-else class="set_img">
            <viewer :images="[paperImage+row.image]">
              <img
                style="min-height:40px;width:140px;cursor:pointer;"
                :src="paperImage+row.image"
                alt
              />
            </viewer>
            <span style="color:#1E77F7;cursor:pointer;" @click="addImg(row.detailId)">修改</span>
            <span style="color:#FE1212;cursor:pointer;" @click="deleteImg(row.detailId)">删除</span>
          </div>
        </template>
      </Table>
    </div>
    <Page :total="page.page*10" :current="page.current" @on-change="handlePage" />
    <Modal v-model="modal" footer-hide width="400">
      <div class="title">上传图片</div>
      <label for="fileInput">
        <div ref="select_frame" class="modal-content">
          <span v-if="!imgSrc">请将图片拖拽至此框或点击加号添加文件</span>
          <Icon type="ios-add" v-if="!imgSrc" size="42" color="#266BF6" />
          <img :src="imgSrc" class="addImg" alt />
        </div>
      </label>
      <input v-show="false" type="file" ref="fileInput" id="fileInput" @change="fileInput($event)" />
      <div class="btns">
        <div class="cancel" @click="cancel">取消</div>
        <div class="ok" @click="upload">确定</div>
      </div>
    </Modal>
    <Modal v-model="modal5" width="350" title="提示" @on-ok="deleteImgOk" @on-cancel="cancel5">
      <p style="font-size:20px;">确定删除此图片？</p>
    </Modal>
  </div>
</template>
<script>
import { Message } from "iview";
import { dealDate } from "../common/common.js";
import globalData from "../common/Global.js";
import {
  _gitPapersBooks,
  _deletePapers,
  _getSheetsDetails,
  _deleteSheetsImages,
  _patchSheetsImages,
  _filesTask
} from "../api/api.js";
export default {
  data() {
    return {
      id: String,
      tables: [
        {
          title: "框ID",
          align: "center",
          key: "detailId"
        },
        {
          title: "章节",
          align: "center",
          key: "sheetName"
        },
        {
          title: "大题号",
          align: "center",
          key: "sectionTitle"
        },
        {
          title: "小题号",
          align: "center",
          key: "index"
        },
        {
          title: "生成时间",
          align: "center",
          key: "createTime"
        },
        {
          title: "题目截图",
          align: "center",
          width: "250",
          slot: "img"
        }
      ],
      modal: false,
      modal5: false,
      selectId: "",
      tableData: [],
      page: {
        page: 1,
        current: 1
      },
      mode: 0, //对于小题的排序
      searchIpt: {},
      imgSrc: "",
      paperImage: globalData.paperImage,
      selectUploadId: "", //选择的上传id
      selectDeleteId: "" //删除图片id
    };
  },
  methods: {
    deleteImgOk() {
      _deleteSheetsImages(this.selectDeleteId).then(res => {
        this.getSheetsDetails();
        this.selectDeleteId = "";
      });
    },
    sumbitData() {
      this.$root.$emit("openUploader", data => {
        _papersBooks({
          name: this.name,
          uri: data.uri,
          size: data.size,
          subject: this.subject,
          grade: this.className
        }).then(res => {
          this.getSheetsDetails();
        });
      });
      this.modal = false;
    },
    cancel() {
      this.modal = false;
    },
    cancel5() {
      this.modal5 = false;
    },
    getNoticeList() {},
    getSheetsDetails() {
      _getSheetsDetails({ id: this.id, page: this.page.page - 1 }).then(res => {
        if (res.code === 0) {
          const { content } = res.data;
          this.page = {
            page: res.data.total / res.data.pageable.size,
            current: res.data.pageable.page + 1
          };
          let questionNo = "";
          let sectionId = "";
          let index_ = 0;
          let text = "";
          this.tableData = content.map((item, index) => {
            if (this.mode == 0) {
              if (questionNo == item.questionNo) {
                if (item.questionOffset) {
                } else {
                  index_ += 1;
                }
              } else {
                questionNo = item.questionNo;
                if (item.sectionId == sectionId) {
                  index_ += 1;
                } else {
                  sectionId = item.sectionId;
                  index_ = 1;
                }
              }
              text = item.questionOffset
                ? index_ + "." + item.questionOffset
                : index_;
            } else {
              text =
                item.questionNo +
                (item.questionOffset ? "." + item.questionOffset : "");
            }
            return {
              detailId: item.detailId,
              sheetName: item.sheetName,
              createTime: dealDate(item.createTime),
              id: item.id,
              index: text,
              sectionTitle: item.sectionTitle,
              image: item.image
            };
          });
        }
      });
    },
    paperBookssTeachersClasses(id) {
      _paperBookssTeachersClasses(id).then(res => {
        if (res.code === 0) {
          Message.success("成功");
        }
      });
    },
    handlePage(e) {
      this.page.page = e;
      this.getSheetsDetails();
    },
    deletePaper() {
      _deletePapers(this.selectIdDelete).then(res => {
        if (res.code === 0) {
          Message.success("成功");
          this.getSheetsDetails();
        }
      });
    },
    fileInput(el) {
      if (!el.target.files[0].size) return;
      if (!/(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)/.test(el.target.files[0].type)) {
        return Message.warning("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
      }
      var reader = new FileReader();
      reader.readAsDataURL(el.target.files[0]);
      reader.onload = e => {
        this.imgSrc = reader.result;
        this.$refs.fileInput.value = null;
      };
    },
    upload() {
      //base64转换成文件上传
      if (!this.imgSrc) {
        return Message.warning("请先选择图片");
      }
      const formData = new FormData();
      var arr = this.imgSrc.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const type = mime.match(/\/(\S*)/)[1];
      const flie = new File([u8arr], `123.${type}`, { type: mime });
      formData.append("file", flie);
      _filesTask(formData).then(res => {
        if (res.code === 0) {
          _patchSheetsImages({
            questionId: this.selectUploadId,
            image: res.data.uri
          }).then(res => {
            this.getSheetsDetails();
            this.selectUploadId = "";
            this.imgSrc = "";
          });
        }
      });
      this.modal = false;
    },
    addImg(id) {
      this.selectUploadId = id;
      this.modal = true;
    },
    deleteImg(id) {
      this.selectDeleteId = id;
      this.modal5 = true;
    }
  },
  mounted() {
    this.$refs.select_frame.ondragleave = e => {
      e.preventDefault(); //阻止离开时的浏览器默认行为
    };
    this.$refs.select_frame.ondrop = e => {
      e.preventDefault(); //阻止拖放后的浏览器默认行为
      const data = e.dataTransfer.files; // 获取文件对象
      if (data.length < 1) {
        return; // 检测是否有文件拖拽到页面
      }
      if (
        !/(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)/.test(e.dataTransfer.files[0].type)
      ) {
        return Message.warning("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
      }
      var reader = new FileReader(); //这是核心,读取操作就是由它完成.
      reader.readAsDataURL(e.dataTransfer.files[0]);
      reader.onload = e => {
        this.imgSrc = reader.result;
      };
    };
    this.$refs.select_frame.ondragenter = e => {
      e.preventDefault(); //阻止拖入时的浏览器默认行为
      this.$refs.select_frame.border = "2px dashed red";
    };
    this.$refs.select_frame.ondragover = e => {
      e.preventDefault(); //阻止拖来拖去的浏览器默认行为
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.mode = this.$route.query.mode;
    this.getSheetsDetails();
  }
};
</script>
<style scoped>
.ivu-modal-body {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: center;
  min-height: 200px;
}
.table {
  margin: 15px 0 25px 0;
}
.ivu-page {
  display: flex;
  justify-content: center;
}
.title {
  font-size: 18px;
  color: rgba(51, 51, 51, 1);
  line-height: 55px;
  text-align: center;
}
.modal-content {
  width: 100%;
  height: 185px;
  text-align: center;
  line-height: 264px;
  border: 2px solid rgba(38, 107, 246, 1);
  border-radius: 10px;
  position: relative;
  font-size: 18px;
  color: rgba(153, 153, 153, 1);
}
.ivu-icon-ios-add {
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.cancel {
  width: 148px;
  height: 40px;
  border: 2px solid rgba(38, 107, 246, 1);
  border-radius: 6px;
  line-height: 40px;
  font-size: 18px;
  font-weight: 400;
  color: rgba(30, 119, 248, 1);
  text-align: center;
}
.ok {
  width: 148px;
  height: 40px;
  background: linear-gradient(
    175deg,
    rgba(64, 188, 243, 1),
    rgba(63, 130, 254, 1)
  );
  border-radius: 6px;
  font-size: 18px;
  font-weight: 400;
  line-height: 40px;
  color: rgb(255, 255, 255);
  text-align: center;
}
.btns {
  padding: 0 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.addImg {
  position: absolute;
  width: auto;
  height: auto;
  max-height: 100%;
  max-width: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 5px;
}
.set_img {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionBank.vue